module.exports = __webpack_public_path__ + "static/media/p4.3d64fc87.jpg";